/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { Button, ButtonGroup } from "@mui/material";
import { useCurrentDynamicField } from "cms/fields/dynamic-field/index";

const UpDownButtons = (props) => {
    
    const handleUp = props?.handleUp;
    const handleDown = props?.handleDown;
    const upDisabled = props?.upDisabled ?? false;
    const downDisabled = props?.downDisabled ?? false;

    const { field } = useCurrentDynamicField();
    const list = field?.list;
    const values = field?.values;

    const ariaLabelUp = upDisabled ? "can not move up" : "move up";
    const ariaLabelDown = downDisabled ? "can not move down" : "move down";
    const buttonStyle = { backgroundColor: "transparent", width: "20px", minWidth: "20px" };

    return (
        <div className='position-buttons'>
            {list && values.length > 1 &&
                <ButtonGroup orientation='vertical'>
                    <Button
                        key='up'
                        color='neutral'
                        disabled={upDisabled}
                        onClick={handleUp}
                        aria-label={ariaLabelUp}
                        style={buttonStyle}
                    >
                        <KeyboardArrowUpOutlinedIcon sx={{ fontSize: 20 }} />
                    </Button>
                    <Button
                        key='down'
                        color='neutral'
                        disabled={downDisabled}
                        onClick={handleDown}
                        aria-label={ariaLabelDown}
                        style={buttonStyle}
                    >
                        <KeyboardArrowDownOutlinedIcon sx={{ fontSize: 20 }} />
                    </Button>
                </ButtonGroup>
            }
        </div>
    );
};

UpDownButtons.displayName = "UpDownButtons";
export { UpDownButtons };
